import { useState, useMemo } from 'react'
import type { PageSize } from '../components/ui/Pagination'

/**
 * Helper pentru paginație client-side: ia un array și returnează slice pentru pagina curentă.
 * Folosește când datele sunt încărcate în întregime (nu pagination server-side).
 */
export function useClientPagination<T>(items: T[], initialPageSize: PageSize = 10) {
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState<PageSize>(initialPageSize)

  const total = items.length

  // Reset pe pagina 1 dacă schimbam page size sau lista a scăzut sub indexul curent
  const safePage = page * pageSize >= total ? 0 : page

  /*
    Felia se ia din pagina SIGURA (21.10.2026). Se lua din `page`: pe pagina 2, o cautare care lasa
    10 rezultate taia `slice(50, 100)` — tabel gol, desi bara spunea „10 comenzi".
  */
  const paginated = useMemo(
    () => items.slice(safePage * pageSize, (safePage + 1) * pageSize),
    [items, safePage, pageSize],
  )

  return {
    page: safePage,
    pageSize,
    total,
    paginated,
    setPage,
    setPageSize: (s: PageSize) => {
      setPageSize(s)
      setPage(0)
    },
  }
}
